import { Platform } from 'react-native';
import { fetchProducts, type ProductSubscription } from 'expo-iap';
import { getAppleProductId, initIAPConnection } from './appleIapService';
import { getGoogleProductId } from './googlePlayIapService';

/** Preço mensal da assinatura (R$) que a loja de fato cobra. */
function priceOf(product: ProductSubscription): number | null {
  if (typeof product.price === 'number' && product.price > 0) return product.price;
  if (product.platform !== 'android') return null;
  // Assinatura no Google: o preço vem na fase do plano básico (sem `offerId`).
  const offers = product.subscriptionOfferDetailsAndroid ?? [];
  const phase = (offers.find((o) => !o.offerId) ?? offers[0])?.pricingPhases.pricingPhaseList.at(-1);
  const micros = phase ? Number(phase.priceAmountMicros) : NaN;
  return Number.isFinite(micros) && micros > 0 ? micros / 1_000_000 : null;
}

/**
 * Preço de cada plano na loja do aparelho (App Store ou Google Play). No app,
 * o cartão do plano mostra este, não o do Stripe: a loja tem tabela própria.
 */
export async function fetchStorePlanPrices(planIds: string[]): Promise<Record<string, number>> {
  const productIdOf = Platform.OS === 'ios' ? getAppleProductId : getGoogleProductId;
  const byProduct = new Map<string, string>();
  for (const planId of planIds) {
    const productId = productIdOf(planId);
    if (productId) byProduct.set(productId, planId);
  }
  if (!byProduct.size) return {};

  await initIAPConnection();
  const products = ((await fetchProducts({ skus: [...byProduct.keys()], type: 'subs' })) ??
    []) as ProductSubscription[];

  const prices: Record<string, number> = {};
  for (const product of products) {
    const planId = byProduct.get(product.id);
    const price = priceOf(product);
    if (planId && price != null) prices[planId] = price;
  }
  return prices;
}
